import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import auth from './auth'
import theme from './theme'
import useHistory from './use-history'
import category from './category'
import navbar from './navbar'
import popupError from './popup-error'
import dialog from './dialog'
import step from './step'
import afterSurvey from './after-survey'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    auth,
    theme,
    useHistory,
    category,
    navbar,
    popupError,
    dialog,
    step,
    afterSurvey,
  }
})
